import { render } from "./AddressInformation.vue?vue&type=template&id=732a923e&scoped=true"
import script from "./AddressInformation.vue?vue&type=script&lang=js"
export * from "./AddressInformation.vue?vue&type=script&lang=js"

import "./AddressInformation.vue?vue&type=style&index=0&id=732a923e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732a923e"]])

export default __exports__